import * as React from 'react';

import './IEIncompatible.pcss';
import { BROWSER_SUGGESTION, UIState } from 'data/UIState';

export const IEIncompatible = (props:{message:string}) => {
  if(UIState.internetExplorerDetected) { 
  return (
    <div className="notice">
      <i className="material-icons">error_outline</i>
      <h2>Internet Explorer Issue</h2>
      <p>{`${props.message} ${BROWSER_SUGGESTION}`}</p>
    </div>
  );
  } else {
    return null;
  }
};
